import getApi from '../../api'

export const deleteConversation = (ulid: string) =>
  getApi().delete<void>(`/stats_assistant/conversations/${ulid}`)
